var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.33325 12.8333C2.33325 10.256 4.42259 8.16665 6.99992 8.16665C9.57726 8.16665 11.6666 10.256 11.6666 12.8333H10.4999C10.4999 10.9003 8.93291 9.33331 6.99992 9.33331C5.06692 9.33331 3.49992 10.9003 3.49992 12.8333H2.33325ZM6.99992 7.58331C5.06617 7.58331 3.49992 6.01706 3.49992 4.08331C3.49992 2.14956 5.06617 0.583313 6.99992 0.583313C8.93367 0.583313 10.4999 2.14956 10.4999 4.08331C10.4999 6.01706 8.93367 7.58331 6.99992 7.58331ZM6.99992 6.41665C8.28908 6.41665 9.33325 5.37248 9.33325 4.08331C9.33325 2.79415 8.28908 1.74998 6.99992 1.74998C5.71075 1.74998 4.66659 2.79415 4.66659 4.08331C4.66659 5.37248 5.71075 6.41665 6.99992 6.41665Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.eeb392af49a9a97c4e9eb776035216fe.svg";
export { ForwardRef as ReactComponent };